export default __webpack_public_path__ + "static/media/MicrosoftTeams-image (2).3467eb5d.png";